import { useEffect } from 'react';
import { useLocation } from 'react-router';

// Alleen de homepage hoort in een index. De rest is of een foutpagina of zit
// achter een login; een crawler krijgt daar index.html met de marketing-meta
// terug en zou dat als duplicaat indexeren.
const INDEXABLE_PATHS = ['/'];

export function useRobotsMeta(): void {
  const { pathname } = useLocation();

  useEffect(() => {
    const shouldIndex = INDEXABLE_PATHS.includes(pathname);
    let tag = document.querySelector<HTMLMetaElement>('meta[name="robots"]');
    if (!tag) {
      tag = document.createElement('meta');
      tag.name = 'robots';
      document.head.appendChild(tag);
    }
    tag.content = shouldIndex ? 'index,follow,max-image-preview:large' : 'noindex,follow';
  }, [pathname]);
}
